export enum FeatureAnalysisEssentialFilterLevel {
  All = "All",
  Essential = "Essential",
  NonEssential = "NonEssential",
}
